import "./Policies.module.css";
import Header from "@/reusable_sections/Header";
import PoliciesHub from "./sections/PoliciesHub";
import Footer from "@/reusable_sections/Footer";
export default function PoliciesPage() {
  return <div>
      <Header />
      <PoliciesHub />
      <Footer />
    </div>;
}